import { FC, useRef, useState } from 'react'
import { useTranslation } from "react-i18next";
import css from './index.module.less'
import { AutoCenter, DotLoading, List, SearchBar } from 'antd-mobile'
import { getQuestionListApi } from '@/api/home'
import { useStoreState } from '@/store'
import { useUpdateEffect } from '@/hooks/useUpdateEffect'
import InfiniteScrollTem from '@/components/InfiniteScrollContent'
import { useNav } from '@/hooks/useNav'
import { Link } from 'react-router-dom'
import { getLngToApi } from '@/utils/getLng'

export const Search: FC = props => {
  const [questionList, setQuestionList] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, size: 20 });
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('')
  const timer = useRef(null)
  const { centerConfig }: any = useStoreState();
  const { t } = useTranslation();


  // 获取问题列表
  const getQuestionList = async () => {
    const res = await getQuestionListApi({
      centerId: centerConfig.id,
      language: getLngToApi(),
      text,
      ...pagination,
    }).finally(() => setLoading(false))
    if (res?.code === 0) {
      setQuestionList(prevState => ([...prevState, ...res.data.records]));
      setPagination(prevState => ({ ...prevState, current: prevState.current + 1 }));
      setHasMore(res.data.current < res.data.pages);
    }
  }

  // 改变搜索文本则重置分页并获取问题列表
  useUpdateEffect(() => {
    timer.current = setTimeout(() => {
      setLoading(true)
      setQuestionList([]);
      getQuestionList();
    }, 1000)
    return () => clearTimeout(timer.current)
  }, [text])

  const onChange = text => {
    setText(text)
    setPagination(prevState => ({ ...prevState, current: 1 }))
  }

  const { nav, genLink } = useNav();
  const onClick = deployId => nav(`/question-detail/${deployId}`);

  return (
    <div className={css.Page}>

      <div className={css.ToolBar}>
        <SearchBar className={css.SearchBar} placeholder={t('common.search-placeholder')} value={text} onChange={onChange} />
        <Link className={`no-decoration ${css.BtnLogin}`} to={genLink('/')}>{t('common.cancel')}</Link>
      </div>


      {loading ? <AutoCenter><DotLoading color={'primary'} /></AutoCenter> : (
        <>
          <List className={css.List}>
            {questionList.map(item => (
              <List.Item key={item.id} onClick={() => onClick(item.id)}>{item.title}</List.Item>
            ))}
          </List>
          <InfiniteScrollTem loadMore={getQuestionList} hasMore={hasMore} />
        </>
      )}

    </div>
  )
}
